export interface Member {
  id: number | null;
  firstName: string;
  lastName: string;
  civilId: string;
  relationType: string;
  passportNumber: string;
  gender: string;
  dateOfBirth: string;
}

export interface CareplusTransaction {
  id: number;
  policyStartDate: string;
  policyEndDate: string;
  phoneNumber?: string;
  countryCode?: number;
  members: Member[];
  basePremium?: number;
  totalIssueFee?: number;
  policyFee?: number;
  totalAmount?: number;
  amountToBePaid?: number;
  calculatedDiscountAmount?: number;
  promocode?: string;
  promoType?: string;
  promoPercentageAmount?: number;
  promoDiscountAmount?: number;
  promoRewardAmount?: number;
  promoRewardStatus?: string;
}

export class CareplusNewCustomer {
  id?: number;
  firstName: string;
  lastName: string;
  countryCode?: number;
  phoneNumber: string;
  email: string;
  dateOfBirth: string;
  gender: string;
  dependentsCount? : number;
  employeeId?: string;
  amount?: number;
  active?: boolean;
  status?: string;
  transaction?: CareplusTransaction;
}
